import { Button } from '@/components/atoms/Button';
import { SummarySectionWithTitle } from '@/components/molecules';
import { AvatarWithName } from '@/components/molecules/AvatarWithName';

interface TeamRegistrationConfirmationProps {
	userProfilePicture: string;
	firstName: string;
	lastName: string;
	teamName: string;
	captainName: string;
}
export const TeamRegistrationConfirmation = ({
	userProfilePicture,
	firstName,
	lastName,
	teamName,
	captainName
}: TeamRegistrationConfirmationProps) => {
	return (
		<>
			<div className="flex w-full max-w-[800px] flex-col rounded-[12px] p-4 shadow-md">
				<div className="flex items-center">
					<AvatarWithName src={userProfilePicture} alt={`${firstName} - profile picture`} firstName={firstName} lastName={lastName} />
				</div>

				<SummarySectionWithTitle title="Summary">
					<p className="pt-[6px] text-sm">Player registration</p>
					<p className="pt-[22px] text-base">{teamName}</p>
					<div className="flex py-4 text-xs">
						<p>Captain:</p>
						<p className="pl-1">{captainName}</p>
					</div>
					<p className="pb-[32px] pr-12 text-sm text-purple-800">
						Congratulations! You have successfully registered for this team. The captain will be reaching out to you soon!
					</p>
				</SummarySectionWithTitle>

				<Button className="mt-6 h-10 w-[51px] self-start  bg-purple-600 px-4 py-[10px] text-xs font-semibold leading-[18px] hover:bg-brand-900">
					Ok
				</Button>
			</div>
		</>
	);
};
